module.exports = __webpack_public_path__ + "img/icons-create-room.817ede2.svg";